import { render, staticRenderFns } from "./feifangRoom.vue?vue&type=template&id=7515bc7c&scoped=true"
import script from "./feifangRoom.vue?vue&type=script&lang=js"
export * from "./feifangRoom.vue?vue&type=script&lang=js"
import style0 from "./feifangRoom.vue?vue&type=style&index=0&id=7515bc7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7515bc7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7515bc7c')) {
      api.createRecord('7515bc7c', component.options)
    } else {
      api.reload('7515bc7c', component.options)
    }
    module.hot.accept("./feifangRoom.vue?vue&type=template&id=7515bc7c&scoped=true", function () {
      api.rerender('7515bc7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/messagejk/feifangRoom.vue"
export default component.exports